<template>
  <label ref="label" class="b-radio radio" :class="[size, { 'is-disabled': disabled }]" :disabled="disabledAttr" :tabindex="disabled ? false : 0" @keydown.prevent.enter.space="$refs.label.click()">
    <input v-model="computedValue" tabindex="-1" type="radio" :disabled="disabledAttr" :required="required" :name="name" :value="nativeValue" @click.stop>
    <span class="check" :class="type" />
    <span class="control-label">
      <slot /></span>
  </label>
</template>

<script>
  import { defineComponent } from 'vue';

  export default defineComponent({
    emits: ['update:modelValue', 'change'],
    name: 'DRadio',
    props: {
      modelValue: [String, Number, Boolean, Function, Object, Array, Symbol],
      nativeValue: [String, Number, Boolean, Function, Object, Array, Symbol],
      type: String,
      disabled: Boolean,
      required: Boolean,
      name: String,
      size: String,
    },
    data() {
      return {
      };
    },
    computed: {
      disabledAttr() {
        return this.disabled ? true : null;
      },
      computedValue: {
        get() {
          return this.modelValue;
        },
        set(value) {
          this.$emit('update:modelValue', value);
        },
      },
    },
  });
</script>